function addSlashToEnd(str: string) {
  if (!str) return '';
  if (str.endsWith('/')) return str;
  return str + '/';
}

function removeSlashFromStartIfExists(str: string) {
  if (str.startsWith('/')) return str.slice(1);

  return str;
}

export function join(...paths: (string | undefined)[]) {
  const stringPaths = paths.filter((s): s is string => !!s);
  if (!stringPaths.length) return '';
  let joinedPath: string = stringPaths[0];

  for (const path of stringPaths.slice(1)) {
    joinedPath = `${addSlashToEnd(joinedPath)}${removeSlashFromStartIfExists(path)}`;
  }

  return joinedPath;
}
